export default (state) => (state.customer
  && state.customer.premium
  && state.customer.metadata
  && state.customer.metadata.premium
  && state.customer.metadata.premium.slogan) || null
